import * as React from 'react';

// Component
import GenericPopup from '../GenericPopup';

// Utils
import cx from 'classnames';

// Styles
import styles from './styles.scss';

// Types
import { DialogWithButtonConfigsProps } from '@shopee-user/business-customization-types';

const DialogWithButtonConfigs = ({
  shouldShow,
  title,
  content,
  buttonConfigs,
  contentClassName,
  containerClassName,
  onClose,
  contentRef,
}: DialogWithButtonConfigsProps) => {
  return (
    <GenericPopup shouldShow={shouldShow} showOverlay={true} onClose={onClose}>
      <div className={cx(styles.container, containerClassName)}>
        <div className={styles.titleAndContentContainer}>
          {title && (
            <div
              className={cx(styles.title, {
                [styles.titleNoContent]: !content,
              })}
            >
              {title}
            </div>
          )}
          {content && (
            <div
              className={cx(styles.content, contentClassName, {
                [styles.contentNoTitle]: !title,
              })}
              ref={contentRef}
            >
              {content}
            </div>
          )}
        </div>

        <div className={styles.buttonContainer}>
          {buttonConfigs.map(({ text, onClick, disabled }, index) => (
            <div
              key={index}
              onClick={!disabled ? onClick : undefined}
              className={cx(styles.button, {
                [styles.buttonDisabled]: disabled,
                [styles.primaryButton]: index === 0,
              })}
            >
              {text}
            </div>
          ))}
        </div>
      </div>
    </GenericPopup>
  );
};

export default DialogWithButtonConfigs;
